"use client";
import { type Metadata } from "next";
import s from "./not-found.module.css";

export const metadata: Metadata = {
  title: "Error",
};

export default function Error() {
  return (
    <div className={s.wrapper}>
      <h1>500</h1>
    </div>
  );
}
